export const leaderboardRouteNames = {
  Leaderboard: 'leaderboard/leaderboard'
}
